module.exports = __webpack_public_path__ + "static/media/XLD-for-women.5e55f31b.png";